import type { NPCConfig } from '@/entities';
import v2Day1SharedNPCs from "@/config/NPCConfigs/v2/V2Day1SharedNPCs.ts";
// import {StoryManager} from "@/systems";

let filteredShared = v2Day1SharedNPCs.filter(obj=>obj.name !== "Sondakh" && obj.name !== "Holga" && obj.spriteImage !== "assets/sprite/gate_close.png")

const config: NPCConfig[] = [
    //Bunga : lagi didepan rumah kalau didkeetin trigger auto next 'stage;, dia bilang ulang tahn
    //
  ...filteredShared,
  {
    x: 3100,
    y: 1600,
    scale : 1,
    interactionRadius : 100,
    name: '',
    noHitbox : true,
    spriteImage: 'assets/sprite/nada.png', // Use NPC image
    interactOnce: true,
    dialogTree: {
      triggerOnCollision: true,
      startDialogId: 'kuburan1',
      nodes: {
        kuburan1: {
          id: 'penjual_part1_1',
          speaker: 'Yan',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          text: `Apa itu?`,
          sfx : "doorKnock",
          nextDialogId : "kuburan2",
          isEnd : true,
        },
      },
    },
  },
  {
    x: 2415,
    y: 1875,
    // x: 2480,
    // y: 1860,
    name: '',
    color: 0x9932cc,
    scale : 0.5,
    repeatable : true,
    flipSprite : false,
    spriteImage: 'assets/sprite/glitter_small.gif',
    dialogTree: {
      startDialogId: 'gate_1',
      nodes: {
        gate_1: {
          id: 'toilet_1',
          speaker: 'Yan',
          text: 'Pintu ini terbuka?',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/cutscene/gate.ktx2',
          nextDialogId : "gate_2"
        },
        gate_2: {
          id: 'toilet_1',
          speaker: 'Yan',
          text: 'Apa ini?',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/cutscene/gate.ktx2',
          nextDialogId : "gate_3"
        },
        gate_3: {
          id: 'toilet_1',
          speaker: 'Yan',
          text: 'Ada kain berdarah yang tersangkut di pintu ini. Dari manakah kira-kira?',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/cutscene/gate.ktx2',
          nextDialogId : "gate_3",
          isEnd : true,
        },
      },
    },
  },
  {
    x: 3600,
    y: 1710,
    name: 'Holga',
    spriteImage: 'assets/sprite/sprite_holga.png', // Use NPC image
    dialogTree: {
      startDialogId: 'holga_1',
      nodes: {
        holga_1: {
          id: 'holga_1',
          speaker: 'Holga',
          text: `Apakah kamu melihat anak saya?`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/rumah.ktx2',
          nextDialogId : "holga_2",
        },
        holga_2: {
          id: 'holga_2',
          speaker: 'Holga',
          text: `Dia gadis paling cantik di desa ini.`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/rumah.ktx2',
          nextDialogId : "holga_3",
        },
        holga_3: {
          id: 'holga_3',
          speaker: 'Holga',
          text: `Saya pergi ke gereja sebentar, saat kembali ke rumah dia sudah tidak dirumah`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/rumah.ktx2',
          isEnd : true
        },
      },
    },
  },
  {
    x: 5780,
    y: 2280,
    name: '',
    color: 0x9932cc, // Dark orchid
    stopInteraction : true,
    spriteImage: 'assets/sprite/sprite_sondakh_dead.png', // Use NPC image
    dialogTree: {
      startDialogId: 'bunga_part2_1',
      nodes: {
        bunga_part2_1: {
          id: 'bunga_part2_1',
          speaker: '',
          text: ``,
          backgroundImage: '/assets/cutscene/death_sondakh.ktx2',
          nextDialogId : "bunga_day1_2",
          isEnd : true
        },
      },
    },
  },
  {
    x: 1810,
    y: 1520,
    name: 'Nenek',
    spriteImage: 'assets/sprite/sprite_nenek1.png', // Use NPC image
    dialogTree: {
      startDialogId: 'nenek1',
      nodes: {
        nenek1: {
          id: 'nenek1',
          speaker: 'Nenek',
          text: `Selamat siang Yan`,
          characterImage: '/assets/character/v2/nene_keriput.png',
          backgroundImage: '/assets/backdrop/rumah.ktx2',
          nextDialogId : "nenek2",
        },
        nenek2: {
          id: 'nenek2',
          speaker: 'Nenek',
          text: ``,
          characterImage: '/assets/character/v2/nene_keriput.png',
          backgroundImage: '/assets/backdrop/rumah.ktx2',
          choices: [
            {
              text: 'Selamat siang nek, apakah nenek sudah lebih sehat?',
              nextDialogId: 'nenek3a',
            },
            {
              text: 'Selamat siang nek, sedang apa?',
              nextDialogId: 'nenek3b',
            },
          ],
        },
        nenek3a: {
          id: 'nenek3a',
          speaker: 'Nenek',
          text: `Kabar nenek sangat baik. Hari ini nenek lebih sehat daripada kemarin.`,
          characterImage: '/assets/character/v2/nene_keriput.png',
          backgroundImage: '/assets/backdrop/rumah.ktx2',
          nextDialogId : "nenek2",
          isEnd : true
        },
        nenek3b: {
          id: 'nenek3b',
          speaker: 'Nenek',
          text: `Nenek sedang berjemur, cuacanya hari ini sangat baik ya.`,
          characterImage: '/assets/character/v2/nene_keriput.png',
          backgroundImage: '/assets/backdrop/rumah.ktx2',
          nextDialogId : "nenek2",
          isEnd : true
        },
      },
    },
  },
  {
    x: 5850,
    y: 1550,
    name: 'Elsa',
    color: 0x9932cc, // Dark orchid
    spriteImage: 'assets/sprite/sprite_elsa.png', // Use NPC image
    dialogTree: {
      startDialogId: 'elsa_1',
      // triggerOnCollision: true,
      nodes: {
        elsa_1: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Yan! Kita butuh bantuan!`,
          characterImage: '/assets/character/v2/elsa_p.png',
          backgroundImage: '/assets/backdrop/danau.ktx2',
          nextDialogId : "elsa_2",
        },
        elsa_2: {
          id: 'elsa_2',
          speaker: 'Elsa',
          text: ``,
          characterImage: '/assets/character/v2/elsa_p.png',
          backgroundImage: '/assets/backdrop/danau.ktx2',
          choices: [
            {
              text: 'Jangan panik, jelaskan apa yang terjadi.',
              nextDialogId: 'elsa_3',
            },
            {
              text: 'Ada apa, kenapa kamu terburu-buru Elsa?',
              nextDialogId: 'elsa_3',
            },
          ],
        },
        elsa_3: {
          id: 'elsa_1',
          speaker: 'Elsa',
          text: `Aku dan Diana menemukan mayat!`,
          characterImage: '/assets/character/v2/elsa_c.png',
          backgroundImage: '/assets/backdrop/danau.ktx2',
          nextDialogId : "elsa_4",
        },
        elsa_4: {
          id: 'elsa_4',
          speaker: 'Elsa',
          text: `Aku harus cepat kembali ke orang desa dan meminta bantuan!`,
          characterImage: '/assets/character/v2/elsa_c.png',
          backgroundImage: '/assets/backdrop/danau.ktx2',
          nextDialogId : "elsa_4",
          isEnd : true
        },
      },

    },

  },
  {
    x: 5820,
    y: 2250,
    name: 'Diana',
    color: 0x9932cc, // Dark orchid
    spriteImage: 'assets/sprite/sprite_diana.png', // Use NPC image
    dialogTree: {
      startDialogId: 'diana_1',
      nodes: {
        diana_1: {
          id: 'diana_1',
          speaker: 'Diana',
          text: `Kak Yan! Apa yang harus kita lakukan!`,
          backgroundImage: '/assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/diana_s.png',
          nextDialogId : "diana_2",
        },
        diana_2: {
          id: 'diana_2',
          speaker: 'Diana',
          text: ``,
          backgroundImage: '/assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/diana_s.png',
          choices: [
            {
              text: 'Tenang dulu Diana, bisakah kamu menjelaskan apa yang terjadi?',
              nextDialogId: 'diana_3',
            },
            {
              text: 'Sebaiknya kita menunggu Elsa kembali dengan orang-orang desa.',
              nextDialogId: 'diana_end_1',
            },
          ],
        },
        diana_end_1: {
          id: 'diana_end_1',
          speaker: 'Diana',
          text: `Sepertinya, Elsa telah kembali dengan orang-orang desa.`,
          backgroundImage: '/assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/diana_c.png',
          //Ini harusnya day ender?
          nextDialogId : "part4_op1",
        },
        diana_3: {
          id: 'diana_3',
          speaker: 'Diana',
          text: `Aku sedang berjalan kembali ke desa bersama Elsa, kami ingin menjemput kak Yan.`,
          backgroundImage: '/assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/diana_c.png',
          nextDialogId: 'diana_4',
        },
        diana_4: {
          id: 'diana_4',
          speaker: 'Diana',
          text: `Lalu kita melihat ada sesuatu di balik semak-semak hanyut.`,
          backgroundImage: '/assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/diana_c.png',
          nextDialogId: 'diana_5',
        },
        diana_5: {
          id: 'diana_5',
          speaker: 'Diana',
          text: `....`,
          backgroundImage: '/assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/diana_c.png',
          nextDialogId: 'diana_end_1',
        },

        part4_op1: {
          id: 'part4_op1',
          speaker: 'Ato',
          text: `Ada apa ini!! Apa yang kalian telah perbuat!`,
          characterImage: '/assets/character/v2/ato_a.png',
          backgroundImage: '/assets/backdrop/danau.ktx2',
          nextDialogId: 'part4_op2',
        },
        part4_op2: {
          id: 'part4_op2',
          speaker: 'Elsa',
          text: `Tadi.. kami hanya...`,
          characterImage: '/assets/character/v2/elsa_s.png',
          backgroundImage: '/assets/backdrop/danau.ktx2',
          nextDialogId: 'part4_op3',
        },
        part4_op3: {
          id: 'part4_op2',
          speaker: 'Holga',
          text: `Minggir!`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/danau.ktx2',
          nextDialogId: 'part4_op4',
        },
        part4_op4: {
          id: 'part4_op2',
          speaker: 'Holga',
          text: `Ya ampun apa yang terjadi ini anak saya!`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/danau.ktx2',
          nextDialogId: 'part4_op5',
        },
        part4_op5: {
          id: 'part4_op2',
          speaker: 'Holga',
          text: `Apa yang telah kau perbuat dik!`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/danau.ktx2',
          nextDialogId: 'part4_op6',
        },
        part4_op6: {
          id: 'part4_op2',
          speaker: 'Elsa',
          text: `Saat saya temukan kondisinya sudah seperti ini.`,
          characterImage: '/assets/character/v2/elsa_p.png',
          backgroundImage: '/assets/backdrop/danau.ktx2',
          nextDialogId: 'part4_op7',
        },
        part4_op7: {
          id: 'part4_op2',
          speaker: 'Holga',
          text: `Jangan bohong kamu!! Pasti ulah kamu!!`,
          characterImage: '/assets/character/v2/holga.png',
          backgroundImage: '/assets/backdrop/danau.ktx2',
          nextDialogId: 'part4_op8',
        },
        part4_op8: {
          id: 'part4_op2',
          speaker: 'Ato',
          text: `Oh ternyata kamu biangnya? Sini kamu!`,
          characterImage: '/assets/character/v2/ato.png',
          backgroundImage: '/assets/backdrop/danau.ktx2',
          nextDialogId: 'part4_op9',
        },
        part4_op9: {
          id: 'part4_op2',
          speaker: 'Romo Darius',
          text: `Ato, Holga! Harap tenang!`,
          characterImage: '/assets/character/v2/darius_a.png',
          backgroundImage: '/assets/backdrop/danau.ktx2',
          nextDialogId: 'part4_op10',
        },
        part4_op10: {
          id: 'part4_op2',
          speaker: 'Romo Darius',
          text: `Sebaiknya kita jangan gegabah. Gadis muda, bisa dijelaskan apa yang terjadi?`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/danau.ktx2',
          nextDialogId: 'part4_op11',
        },
        part4_op11: {
          id: 'part4_op10',
          speaker: 'Elsa',
          text: `Saya dan Diana sedang berjalan kembali ke arah kota.`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/danau.ktx2',
          nextDialogId: 'part4_op12',
        },
        part4_op12: {
          id: 'part4_op11',
          speaker: 'Elsa',
          text: `Kami hanya menemukan mayat gadis ini saja, karena panik saya langsung lari meminta pertolongan.`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/danau.ktx2',
          nextDialogId: 'part4_op13',
        },
        part4_op13: {
          id: 'part4_op2',
          speaker: 'Romo Darius',
          text: `Apakah kalian melihat sesuatu setelah atau sebelum kejadian ini? `,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/danau.ktx2',
          nextDialogId: 'part4_op14',
        },
        part4_op14: {
          id: 'part4_op11',
          speaker: 'Elsa',
          text: `Tidak ada...`,
          characterImage: '/assets/character/v2/elsa.png',
          backgroundImage: '/assets/backdrop/danau.ktx2',
          nextDialogId: 'part4_op15',
        },
        part4_op15: {
          id: 'part4_op11',
          speaker: 'Diana',
          text: `Maaf romo, aku tidak kepikiran apa-apa.`,
          characterImage: '/assets/character/v2/diana.png',
          backgroundImage: '/assets/backdrop/danau.ktx2',
          nextDialogId: 'part4_op16',
        },
        part4_op16: {
          id: 'part4_op2',
          speaker: 'Romo Darius',
          text: `Baiklah, kalian harap tenang juga `,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/danau.ktx2',
          nextDialogId: 'part4_op17',
        },
        part4_op17: {
          id: 'part4_op2',
          speaker: 'Romo Darius',
          text: `Ato, panggil-lah orang-orang lain, kita harus bergegas memindahkan mayat ke kota.`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/danau.ktx2',
          nextDialogId: 'part4_op18',
        },
        part4_op18: {
          id: 'part4_op2',
          speaker: 'Romo Darius',
          text: `Yan, aku dengar kamu dokter?`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/danau.ktx2',
          nextDialogId: 'part4_op19',
        },
        part4_op19: {
          id: 'part4_op2',
          speaker: 'Romo Darius',
          text: `Bisakah kamu lakukan otopsi singkat?`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/danau.ktx2',
          nextDialogId: 'part4_op20',
        },
        part4_op20: {
          id: 'part4_op2',
          speaker: 'Romo Darius',
          text: `Memang di desa ini tidak ada teknologi apapun yang bisa membantu kamu`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/danau.ktx2',
          nextDialogId: 'part4_op21',
        },
        part4_op21: {
          id: 'part4_op2',
          speaker: 'Romo Darius',
          text: `Tapi akan sangat baik jika kamu bisa mendapatkan informasi mengenai kematian Sondakh.`,
          characterImage: '/assets/character/v2/darius.png',
          backgroundImage: '/assets/backdrop/danau.ktx2',
          nextDialogId: 'part4_op19',
          storyAction: { type: 'nextDay', value: 1 },
          isEnd : true
        },

      },
    },
  },

  {
    x: 4400,
    y: 2500,
    name: 'Bunga',
    flipSprite : true,
    repeatable : false,
    color: 0x9932cc, // Dark orchid
    spriteImage: 'assets/sprite/sprite_bunga.png', // Use NPC image
    dialogTree: {
      startDialogId: 'bunga_1',
      nodes: {
        bunga_1: {
          id: 'merchant_greeting',
          speaker: 'Bunga',
          text: `Halo Yan, akhirnya kamu sampai juga.`,
          backgroundImage: '/assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/bunga.png',
          nextDialogId: 'bunga_2',
        },
        bunga_2: {
          id: 'merchant_greeting',
          speaker: 'Bunga',
          text: `Dimana yang lain?`,
          backgroundImage: '/assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/bunga.png',
          nextDialogId: 'bunga6',
        },
        bunga6: {
          id: 'merchant_greeting',
          speaker: 'Bunga',
          text: ``,
          backgroundImage: '/assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/bunga.png',
          nextDialogId: 'bunga7',
          choices: [
            {
              text: 'Sepertinya kita harus segera berberes-beres, sepertinya Diana dan Elsa butuh bantuan kita',
              nextDialogId: 'bunga_end_1',
              storyActions: [
                { type: 'addState', value: "BUNGA_ON_SONDAKH_DEATH" },
                { type: 'removeState', value: "BUNGA_NOT_ON_SONDAKH_DEATH" },
                { type: 'addCustomValue', value: {key : "general_karma", value : 1} }
              ],
            },
            {
              text: 'Aku tidak melihat mereka. Mungkin lebih baik kita mulai berdua dulu.',
              nextDialogId: 'bsus_1',
              storyActions: [
                  { type: 'addCustomValue', value: {key : "bunga_affinity", value : 1} },
                  { type: 'addCustomValue', value: {key : "general_karma", value : -1} },
              ],
            },
          ],
        },
        bunga_end_1: {
          id: 'merchant_greeting',
          speaker: 'Bunga',
          text: `Diana membutuhkan bantuan kita? `,
          backgroundImage: '/assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/bunga.png',
          nextDialogId: 'bunga_end_2',
        },
        bunga_end_2: {
          id: 'merchant_greeting',
          speaker: 'Bunga',
          text: `Ayo kita bergegas`,
          backgroundImage: '/assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/bunga.png',
          nextDialogId: '',
          isEnd : true
        },

        bsus_1: {
          id: 'merchant_greeting',
          speaker: 'Bunga',
          text: `Mari bersenang-senang!`,
          backgroundImage: '/assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/bunga.png',
          nextDialogId: 'bsus_2',
          storyActions : [
            { type: 'addState', value: "BUNGA_BATH" },
          ],
        },
        bsus_2: {
          id: 'merchant_greeting',
          speaker: '',
          text: ``,
          backgroundImage: '/assets/cutscene/black.ktx2',
          fade : true,
          autoplay : 1,
          nextDialogId: 'bsus_3',
        },
        bsus_3: {
          id: 'merchant_greeting',
          speaker: 'Bunga',
          text: `Aku sedikit malu Yan, terakhir kita melakukan ini, kita masih kecil, apakah tidak apa2?`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/cutscene/black.ktx2',
          fade : true,
          nextDialogId: 'bsus_4',
        },
        bsus_4: {
          id: 'merchant_greeting',
          speaker: 'Bunga',
          text: ``,
          backgroundImage: '/assets/cutscene/black.ktx2',
          characterImage: '/assets/character/v2/bunga.png',
          nextDialogId: 'bunga7',
          choices: [
            {
              text: 'Apa yang harus dipermalukan',
              nextDialogId: 'bsus_5',
            },
            {
              text: 'Aku juga sedikit malu, tapi tidak apa-apa',
              nextDialogId: 'bsus_5',
            },
          ],
        },
        bsus_5: {
          id: 'merchant_greeting',
          speaker: 'Bunga',
          text: `Baiklah Yan`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/cutscene/black.ktx2',
          nextDialogId: 'bsus_6',
        },
        bsus_6: {
          id: 'merchant_greeting',
          speaker: '',
          text: ``,
          backgroundImage: '/assets/cutscene/mandi_bunga.ktx2',
          nextDialogId: 'bsus_7',
          cinematic : true,
          fade : true,
        },
        bsus_7: {
          id: 'merchant_greeting',
          speaker: '',
          text: ``,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/cutscene/black.ktx2',
          nextDialogId: 'bsus_8',
          autoplay : 1,
          fade : true,
        },
        bsus_8: {
          id: 'merchant_greeting',
          speaker: 'Bunga',
          text: `Sangat menyenangkan, aku senang bisa melakukan ini dengan mu Yan!`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/danau.ktx2',
          nextDialogId: '',
          fade : true,
          isEnd : true,
        },

      },
    },
  },

];

export default config;
